<style lang="less" scoped>
  @import "../../../vars.less";
  .button-container {
    padding: @space-normal @space-normal;
    background-color: #fff;
  }
</style>

<template>
  <div class="special-delivery">
    <van-search
      v-model="conditions.OrderNumber"
      :placeholder="$t('请输入销售订单号')" />
    <van-field :label="$t('流程状态')">
      <template #input>
        <van-radio-group v-model="conditions.CaseStatusCode" direction="horizontal">
          <van-radio name="-1">{{$t('全部')}}</van-radio>
          <van-radio name="0">{{$t('进行中')}}</van-radio>
          <van-radio name="1">{{$t('已完结')}}</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <div class="button-container">
      <van-button type="info" size="small" round block @click="query" >{{ $t('查询特殊发货') }}</van-button>
    </div>
  </div>
</template>

<script>
import { Search, Field, Button, RadioGroup, Radio } from 'vant'

export default {
  name: 'special-delivery',
  components: {
    'van-search': Search,
    'van-field': Field,
    'van-button': Button,
    'van-radio-group': RadioGroup,
    'van-radio': Radio
  },
  data () {
    return {
      conditions: {
        OrderNumber: '',
        CaseStatusCode: '-1'
      },
      showPicker: false
    }
  },
  methods: {
    onConfirm (value) {
      this.conditions.SaleOrderNumber = value
      this.showPicker = false
    },
    query () {
      this.$router.push({
        name: 'special-delivery-list',
        params: {
          stackType: 'push'
        },
        query: this.conditions
      })
    }
  }
}
</script>
